/**
 * @ngdoc service
 * @name checkins.factory:createPicklist
 *
 * @description
 *
 */
angular
    .module('festzelt-os.picklists')
    .factory('createPicklist', [
        '$state',
        createPicklist
    ]);

function createPicklist($state) {
    return {
        key: 'create-picklist',
        title: 'Add new',
        level: 'highlight',
        icon: 'plus-circle',
        action: function ({row}, store) {
            $state.go('app.picklists.create', {store:store});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/picklists/workflows/list/create-picklist.js